import React, { useState, useEffect, useMemo } from "react";
import useMappedState from "@src/utils/useMappedState";
import { i18n } from "@src/utils/i18n";
import history from "@src/utils/history";
import { Button, Modal, Input, message, Tooltip } from "@cloud/atom-ui";
import TestModal from "./component/models/testModal";
import {
  getCallBack,
  handleConfigCallbackUrl,
  handleUpdateAppConfig
} from "./thunk";
import { CHECK_RESULT } from "./constant";
import * as nls from "./nls";
import * as css from "./style.module.less";
import QuestionCircleOutlined from "@cloud/atom-ui-icons/QuestionCircleOutlined";
import CommonHeader from "../../components/common-header";
import { getAppPathFromType, APP_TYPE } from "@src/utils/common";

const I18N = i18n(nls);
const text = I18N;

export default props => {
  const { user } = useMappedState("root");
  const openAddress = /localhost/.test(window.location.hostname)
    ? location.origin
    : "";
  //appId   应用id
  //isvType 版本类型，1开发版，2体验版，0线上版
  //type 类型，1内部we码，2内部轻应用，3第三方we码，4第三方轻应用  5或9 无界面应用
  //appType 轻应用 7   we码 8  无界面应用 9
  const {
    history: {
      queryParams: {
        query: { id: appId }
      }
    }
  } = props;
  const {
    match: {
      params: { type }
    }
  } = props;
  //检查是否有权限操作
  const [isDeveloper] = useState(() => {
    let isDeveloper = true;
    if (user && user.roles && user.roles.length > 0) {
      isDeveloper = user.roles.find(
        obj =>
          obj.roleCode === "applicationsDeveloper" || //应用开发者
          obj.roleCode === "enterpriseAdmin" || //租户管理员
          (obj.roleCode === "appStoreAdmin" && user.isAllAppStoreAdmin) //企业应用管理员
      );
    } else {
      isDeveloper = true;
    }
    return isDeveloper;
  });

  const [callBackUrl, setCallbackUrl] = useState(""); //回调地址
  const [callBackUrlReadonly, setCallbackUrlReadonly] = useState(true); //回调地址只读，true只读，false编辑
  const [modalVisible, setModalVisible] = useState(false); //测试显隐
  const [checkResult, setCheckResult] = useState();
  const [testCallbackUrl, setTestCallbackUrl] = useState("");
  const [jsonParam, setJsonParam] = useState();

  //获得数据
  useEffect(() => {
    //获得回调地址
    getCallBack(appId, getAppPathFromType(type)).then(res => {
      if (res?.configCallbackValue) {
        setTestCallbackUrl(res.configCallbackValue);
        setCallbackUrl(res.configCallbackValue);
      }
    });
  }, []);

  const saveCallbackUrl = async () => {
    const testUrl = (testCallbackUrl || "").replace(/\s*/g, "");
    const insideType = [APP_TYPE.innerapp];
    const saveCallbackFn = insideType.includes(+type)
      ? handleConfigCallbackUrl
      : handleUpdateAppConfig;
    const res = await saveCallbackFn({
      type: "save",
      appId,
      callBackUrl: testUrl,
      appType: type
    });
    if (+res?.status === 1) {
      setCallbackUrl(testUrl);
      setCallbackUrlReadonly(true);
    } else {
      message.error(res.errMsg);
    }
    setModalVisible(!modalVisible);
  };

  const openTestModal = () => {
    //检查http://或https://开头
    if (
      !new RegExp("^((http|https)://).+").test(testCallbackUrl) &&
      testCallbackUrl.length >= 0
    ) {
      message.error("必须以http://或https://开头");
      return;
    }
    setModalVisible(!modalVisible);
    setCheckResult(null);
  };

  return (
    <div>
      <CommonHeader title="事件与回调" headerStyle={{ marginBottom: "51px" }} />
      <div style={{ marginBottom: "80px", position: "relative" }}>
        {isDeveloper && (
          <div key="-1" className={css["chart"]}>
            <div className={css["chart-title"]}>
              事件与回调
              <Tooltip
                placement="topLeft"
                title="请先完成在线调试，方可添加回调地址，未通过校验无法添加回调地址"
              >
                <QuestionCircleOutlined
                  style={{ fontSize: 14, marginLeft: 5 }}
                />
              </Tooltip>
            </div>
            <div className={css["callback-demo"]}>
              <label className={css["callbackName"]}>{text.testOnline}</label>
              <Input
                className={css["callbackValue"]}
                placeholder="必须以http://或https://开头"
                id="backURL"
                value={testCallbackUrl}
                onChange={e => setTestCallbackUrl(e.target.value)}
              />
              <Button
                className={css["callbackBtn"]}
                type="primary"
                onClick={openTestModal}
              >
                {text.test}
              </Button>
            </div>
            <div className={css["callback-demo"]}>
              <label className={css["callbackName"]}>{text.callBackUrl}</label>
              {callBackUrlReadonly && (
                <Input
                  disabled
                  className={css["callBackUrl"]}
                  placeholder={callBackUrl || "--"}
                  defaultValue={callBackUrl}
                />
              )}
            </div>
          </div>
        )}
        <Modal
          destroyOnClose={true}
          title={text.test}
          visible={modalVisible}
          width={600}
          onCancel={() => setModalVisible(!modalVisible)}
          maskClosable={false}
          footer={[
            <Button onClick={() => setModalVisible(!modalVisible)}>
              取消
            </Button>,
            <Button
              type="primary"
              disabled={CHECK_RESULT.PASS !== checkResult}
              onClick={saveCallbackUrl}
            >
              添加到回调
            </Button>
          ]}
        >
          <TestModal
            appId={appId}
            testCallbackUrl={testCallbackUrl}
            appType={type}
            onCheckResult={setCheckResult}
            checkResult={checkResult}
            onSetJsonParam={setJsonParam}
          />
        </Modal>

        <Modal
          destroyOnClose={true}
          title="缺少开发者角色"
          visible={!isDeveloper}
          width={400}
          onCancel={() => {
            type == 5
              ? history.go(-1)
              : history.push(
                  `/${type}/appdetailV2/editionManage?id=${appId}&type=${type}`
                );
          }}
          maskClosable={false}
          footer={[
            <Button
              key={0}
              type="primary"
              onClick={() => {
                type == 5
                  ? history.go(-1)
                  : history.push(
                      `/${type}/appdetailV2/editionManage?id=${appId}&type=${type}`
                    );
              }}
            >
              我知道了
            </Button>
          ]}
          className={css["modalShow"]}
        >
          <p className={css["modalCenter"]}>联系管理员添加开发者角色</p>
          <a
            href={`${openAddress}/docs/#/990hh0/whokyc/vwd3yr`}
            target="_blank"
            className={css["modalCenter"]}
          >
            【如何添加开发者角色】
          </a>
        </Modal>
      </div>
    </div>
  );
};
